import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import { InfoRes, type InfoReq } from '@/types/api/user/info.d';

export const getUserInfo = ({ params }: { params: InfoReq; }) =>
  get<InfoRes>('/user/v1/info', {
    params,
  });

export const useGetUserInfo = createApiQuery(getUserInfo, () => ['user-info']);
